import styled from 'styled-components';
import {
    error,
    robotoRegular,
    scarpaGray25,
    scarpaGray100,
    scarpaGray500,
    scarpaGray900,
    spanishViridian25,
    spanishViridian500,
    spanishViridian600,
} from '@habitech/shared';

export const ModalRoot = styled.div`
    font-family: ${robotoRegular};
    color: ${scarpaGray900};
    padding-top: 8px;
`;

export const ModalTitle = styled.h2`
    margin: 0 0 20px;
    font-size: 20px;
    font-weight: 700;
    color: ${scarpaGray900};
`;

export const NoticeWrapper = styled.div`
    margin-bottom: 20px;
`;

export const FieldsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
`;

export const FieldGroup = styled.div<{ $full?: boolean }>`
    grid-column: ${({ $full }) => ($full ? '1 / -1' : 'auto')};
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
`;

export const FieldLabelRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-height: 20px;
`;

export const FieldLabel = styled.span`
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    color: ${scarpaGray900};

    .no-editable {
        font-size: 11px;
        font-weight: 500;
        color: ${scarpaGray500};
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }
`;

export const OtpBadge = styled.span<{ $verified?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 9px;
    border-radius: 999px;
    background: ${({ $verified }) => ($verified === false ? '#FCE9E9' : spanishViridian25)};
    border: 1px solid ${({ $verified }) => ($verified === false ? error : spanishViridian500)};
    color: ${({ $verified }) => ($verified === false ? error : spanishViridian600)};
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
`;

export const ReadOnlyField = styled.div`
    padding: 0 14px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid ${scarpaGray100};
    background: ${scarpaGray25};
    color: ${scarpaGray500};
    font-size: 14px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const SaveError = styled.div`
    grid-column: 1 / -1;
    color: ${error};
    font-size: 13px;
`;

export const ModalActions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
`;
